export default {
  'pages.mall.config.title': 'Mall Config',
  'pages.mall.config.subtitle':
    'Manage mall reporting config (tenant-store-device-mall)',

  'pages.mall.config.stat.totalConfig': 'Total',
  'pages.mall.config.stat.tenantCount': 'Tenants',
  'pages.mall.config.stat.deviceCount': 'Devices',
  'pages.mall.config.stat.enabledCount': 'Enabled',

  'pages.mall.config.add': 'Add',
  'pages.mall.config.edit': 'Edit',
  'pages.mall.config.delete': 'Delete',
  'pages.mall.config.save': 'Save',
  'pages.mall.config.cancel': 'Cancel',
  'pages.mall.config.confirm': 'OK',
  'pages.mall.config.back': 'Back',
  'pages.mall.config.detail': 'Detail',
  'pages.mall.config.regenerate': 'Regenerate',
  'pages.mall.config.enable': 'Enable',
  'pages.mall.config.disable': 'Disable',

  'pages.mall.config.addTitle': 'Add Mall Config',
  'pages.mall.config.editTitle': 'Edit Mall Config',
  'pages.mall.config.detailTitle': 'Mall Config Detail',

  'pages.mall.config.message.addSuccess': 'Added',
  'pages.mall.config.message.addFailed': 'Add failed',
  'pages.mall.config.message.editSuccess': 'Updated',
  'pages.mall.config.message.editFailed': 'Update failed',
  'pages.mall.config.message.deleteSuccess': 'Deleted',
  'pages.mall.config.message.deleteFailed': 'Delete failed',
  'pages.mall.config.message.deleteConfirm': 'Delete this config?',
  'pages.mall.config.message.statusSuccess': 'Status updated',
  'pages.mall.config.message.statusFailed': 'Status update failed',
  'pages.mall.config.message.regenerateSuccess': 'Force-merge scheduled',
  'pages.mall.config.message.regenerateFailed': 'Force-merge failed',
  // Merged file preview/download (service-level errors)
  'pages.mall.config.file.notFound':
    'File does not exist or has not been generated',
  'pages.mall.config.file.previewNotText':
    'Preview endpoint did not return text (check that the proxy/gateway forwards /pos-api)',
  'pages.mall.config.file.downloadNotFile':
    'Download endpoint did not return a file (check that the proxy/gateway forwards /pos-api)',

  // Force-merge (received < expected) related
  'pages.mall.config.forceMerge.checkbox': 'Force merge with current data',
  'pages.mall.config.forceMerge.checkboxTip':
    'When checked, allows force-merging even if some devices have not uploaded. Result may be incomplete - use with caution',
  'pages.mall.config.forceMerge.confirmTitle': 'Confirm force merge?',
  'pages.mall.config.forceMerge.received': 'Received',
  'pages.mall.config.forceMerge.missing': 'Missing',
  'pages.mall.config.forceMerge.warning':
    'The merged result will be incomplete (missing the devices above) and will be pulled by AAPP and pushed to the mall. Continue?',
  'pages.mall.config.forceMerge.warningShort': 'Missing devices',
  'pages.mall.config.forceMerge.confirm': 'Force merge',
  'pages.mall.config.forceMerge.cancel': 'Cancel',
  'pages.mall.config.forceMerge.disabledTipPrefix': 'Missing devices',
  'pages.mall.config.forceMerge.disabledTipSuffix':
    'Check "Force merge with current data" to enable',
  'pages.mall.config.forceMerge.stillGeneratingTip':
    'Files are still being generated. Wait until generation completes.',
  'pages.mall.config.forceMerge.waitForPullTip':
    'Waiting for devices to pull files ({pulled}/{expected}). All devices must finish pulling before regenerating.',

  'pages.mall.config.divider.basicInfo': 'Basic',
  'pages.mall.config.divider.mallInfo': 'Mall',
  'pages.mall.config.divider.ftpInfo': 'FTP',
  'pages.mall.config.divider.tsmsInfo': 'TSMS (PITX) Credentials',
  'pages.mall.config.divider.smInfo': 'SM Mall Parameters',

  // SM (Mosaic SIA) display parameters (2026-09-28 SM cloud-link batch)
  'pages.mall.config.smSalesType': 'SM Sales Type',
  'pages.mall.config.form.smSalesTypeRequired': 'Please select SM Sales Type',
  'pages.mall.config.form.smParamTip':
    'SM uses row-level cloud upload: the POS uploads CSV lines and the cloud merges monthly T/D files. Sales Type is delivered to the POS via GET /pos/mall/config for line assembly; when empty the POS keeps the local default (SM01)',
  'pages.mall.config.detail.smNoDetail':
    'SM mall uses row-level cloud upload and has no config detail page (files are generated by the mall-side tool)',

  'pages.mall.config.tenant': 'Tenant',
  'pages.mall.config.store': 'Store',
  'pages.mall.config.deviceCodes': 'Devices',
  'pages.mall.config.mallCode': 'Mall',
  'pages.mall.config.mallName': 'Mall Name',
  'pages.mall.config.mallPartnerCode': 'Partner Code',
  'pages.mall.config.businessType': 'Business Type',
  'pages.mall.config.businessType.food': 'Food',
  'pages.mall.config.businessType.nonFood': 'Non-Food',
  'pages.mall.config.businessType.groceries': 'Groceries',
  'pages.mall.config.businessType.medicines': 'Medicines',
  'pages.mall.config.businessType.nonDrugSale': 'Non-Drug Sales',
  'pages.mall.config.businessType.drugSale': 'Drug Sales',
  'pages.mall.config.businessType.others': 'Others',
  'pages.mall.config.status': 'Status',
  'pages.mall.config.ftpHost': 'FTP Host',
  'pages.mall.config.ftpPort': 'FTP Port',
  'pages.mall.config.ftpUser': 'FTP User',
  'pages.mall.config.ftpPassword': 'FTP Password',
  'pages.mall.config.ftpRemoteDir': 'FTP Remote Dir',
  'pages.mall.config.ftpUseFtps': 'Use FTPS',
  'pages.mall.config.remark': 'Remark',
  'pages.mall.config.statusEnabled': 'Enabled',
  'pages.mall.config.statusDisabled': 'Disabled',

  'pages.mall.config.form.input': 'Input',
  'pages.mall.config.form.selectPlaceholder': 'Select',
  'pages.mall.config.form.deviceCodesPlaceholder': 'Select a store first',
  'pages.mall.config.form.tenantRequired': 'Tenant required',
  'pages.mall.config.form.storeRequired': 'Store required',
  'pages.mall.config.form.deviceCodesRequired': 'At least one device',
  'pages.mall.config.form.mallCodeRequired': 'Mall required',
  'pages.mall.config.form.mallNameRequired': 'Mall name required',
  'pages.mall.config.form.mallPartnerCodeRequired': 'Partner code required',
  'pages.mall.config.form.businessTypeRequired': 'Business type required',
  'pages.mall.config.form.passwordKeepPlaceholder':
    'Leave blank to keep current',
  'pages.mall.config.form.useFtpsLabel': 'Use FTPS (SSL/TLS)',
  'pages.mall.config.tsmsTenantId': 'TSMS Tenant ID',
  'pages.mall.config.tsmsBaseUrl': 'TSMS API Base URL',
  'pages.mall.config.tsmsTerminalId': 'Terminal ID',
  'pages.mall.config.tsmsApiToken': 'API Token',
  'pages.mall.config.form.tsmsTenantIdRequired': 'Please enter TSMS tenant ID',
  'pages.mall.config.form.tsmsTerminalNoMissing':
    'Device {device} has no terminal number or it is not numeric. Please fix it in Device Management first.',
  'pages.mall.config.form.tsmsBaseUrlRequired':
    'Please enter TSMS API base URL',
  'pages.mall.config.form.tsmsApiTokenRequired': 'Please enter API token',
  'pages.mall.config.form.tsmsTerminalIdAutoTip':
    'Terminal ID of each bound device is taken from the device profile automatically on save. No manual input needed.',

  'pages.mall.config.column.deviceCodes': 'Devices',
  'pages.mall.config.column.deviceTerminalNos': 'Terminal No',
  'pages.mall.config.column.mall': 'Mall',
  'pages.mall.config.column.businessType': 'Type',
  'pages.mall.config.column.status': 'Status',
  'pages.mall.config.column.createTime': 'Created',
  'pages.mall.config.column.updateTime': 'Updated',
  'pages.mall.config.column.action': 'Action',

  'pages.mall.config.detail.basicInfo': 'Basic Info',
  'pages.mall.config.detail.history': 'Merge Task History',
  'pages.mall.config.detail.historyDateRange': 'Business Date Range',
  'pages.mall.config.detail.col.businessDate': 'Business Date',
  'pages.mall.config.detail.col.fileType': 'File Type',
  'pages.mall.config.detail.col.expected': 'Expected',
  'pages.mall.config.detail.col.received': 'Received',
  'pages.mall.config.detail.col.taskStatus': 'Status',
  'pages.mall.config.detail.col.processTime': 'Processed At',
  'pages.mall.config.detail.col.mergedFile': 'Merged File',
  'pages.mall.config.detail.col.action': 'Action',

  // 主表 8 列结构
  'pages.mall.config.detail.col.mall': 'Mall',
  'pages.mall.config.detail.col.device': 'Device',
  'pages.mall.config.detail.col.terminalNos': 'Terminal No',
  'pages.mall.config.detail.col.generateFiles': 'Files',
  'pages.mall.config.detail.col.generateCount': 'Gen Count',
  'pages.mall.config.detail.col.dataSource': 'Source',
  'pages.mall.config.detail.col.status': 'Status',

  'pages.mall.config.detail.dataSource.value': 'Z-reading',
  'pages.mall.config.detail.generateFiles.value': 'S/H/D/Z',

  'pages.mall.config.detail.status.generated': 'Generated',
  'pages.mall.config.detail.status.failed': 'Failed',
  'pages.mall.config.detail.status.processing': 'Processing',
  'pages.mall.config.detail.status.waitingDevice': 'Waiting for device upload',

  // 详情抽屉
  'pages.mall.config.detail.drawer.title': '{date} Generation Detail',
  'pages.mall.config.detail.drawer.businessDate': 'Business Date',
  'pages.mall.config.detail.drawer.mallName': 'Mall',
  'pages.mall.config.detail.drawer.files': 'Files',
  'pages.mall.config.detail.drawer.filesSuffix': ' files',
  'pages.mall.config.detail.drawer.generateCount': 'Gen Count',
  'pages.mall.config.detail.drawer.countSuffix': ' time(s)',
  'pages.mall.config.detail.drawer.generationLabel': 'Gen #{n}',
  'pages.mall.config.detail.drawer.col.generationNo': 'Generation',
  'pages.mall.config.detail.drawer.col.processTime': 'Generated At',
  'pages.mall.config.detail.drawer.col.files': 'Files',
  'pages.mall.config.detail.drawer.col.action': 'Action',
  'pages.mall.config.detail.drawer.downloadLogTitle': 'Devices Pulled',
  'pages.mall.config.detail.drawer.noDownloadLog':
    'No pull records yet (devices have not pulled merged files)',
  'pages.mall.config.detail.drawer.downloadBtn': 'Download',
  'pages.mall.config.detail.drawer.downloadSuccess': 'Download complete',
  'pages.mall.config.detail.drawer.downloadFailed': 'Download failed',
  'pages.mall.config.detail.drawer.downloadNoFiles':
    'No files available for this generation',

  // 详情页 - 文件预览(此前缺失,本次补全)
  'pages.mall.config.detail.preview': 'Preview',
  'pages.mall.config.detail.previewTitle': '{fileType} File Preview - {date}',
  'pages.mall.config.detail.previewEmpty': 'No content',
  'pages.mall.config.detail.previewLoading': 'Loading...',
  'pages.mall.config.detail.previewFileMissing': 'File not generated',
  'pages.mall.config.detail.previewBtn': '{fileType} Preview',

  // 详情抽屉 - 手动推送 FTP
  'pages.mall.config.detail.drawer.pushFtpBtn': 'Push FTP',
  'pages.mall.config.detail.drawer.pushFtpMissingTip':
    'S/H/D/Z files incomplete, cannot push',
  'pages.mall.config.detail.drawer.pushFtpConfirmTitle':
    'Confirm push to mall FTP?',
  'pages.mall.config.detail.drawer.pushFtpConfirmHost': 'Target FTP',
  'pages.mall.config.detail.drawer.pushFtpConfirmRemoteDir': 'Remote dir',
  'pages.mall.config.detail.drawer.pushFtpConfirmFiles': 'Files to push',
  'pages.mall.config.detail.drawer.pushFtpConfirmWarning':
    'Once confirmed, the 4 files will be uploaded to the mall FTP immediately. Any failure rolls back already uploaded files.',
  'pages.mall.config.detail.drawer.pushFtpConfirm': 'Confirm push',
  'pages.mall.config.detail.drawer.pushFtpCancel': 'Cancel',
  'pages.mall.config.detail.drawer.pushFtpPushing': 'Pushing...',
  'pages.mall.config.detail.drawer.pushFtpSuccess': 'Push success',
  'pages.mall.config.detail.drawer.pushFtpFailed': 'Push failed',

  'pages.mall.config.taskStatus.waiting': 'Waiting',
  'pages.mall.config.taskStatus.merging': 'Merging',
  'pages.mall.config.taskStatus.success': 'Success',
  'pages.mall.config.taskStatus.failed': 'Failed',
};
